import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { ShiftLedgerSummary } from '@/api/models';
import { ShiftQueryKeys } from './shiftQueryKeys';

/**
 * What one shift posted, per account (`GET /shifts/{id}/ledger-summary`).
 * Issues no request until a shift is chosen. `locale` picks the account-name
 * translation. Unwraps the envelope and throws its `ErrorResponse`.
 */
export const useShiftLedgerSummaryQuery = (
    shiftId: string | null,
    locale: string,
) => {
    const { apiClient } = useApi();

    return useQuery<ShiftLedgerSummary>({
        queryKey: ShiftQueryKeys.ledgerSummary(shiftId ?? '', locale),
        queryFn: async () => {
            const result = await apiClient.shifts.getLedgerSummary(
                shiftId ?? '',
                locale,
            );
            if (!result.success) {
                throw result.error;
            }
            return result.response;
        },
        enabled: shiftId !== null,
        staleTime: 0,
    });
};
